import React from 'react';
import { FormattedMessage } from 'react-intl';

import { assertUnreachable } from 'utils/assertUnreachable';

import { ConsentVariant } from './apiResponse';

export const consentMessage = (
  consentVariant: ConsentVariant,
  company: string,
) => {
  switch (consentVariant) {
    case 'UPS':
      return (
        <FormattedMessage
          defaultMessage="By providing your phone number and checking this box, you agree to receive text messages and voice calls at that number from UPS, including messages related to your application(s) and other UPS job opportunities, as well as work-related text messages if you are hired. You can opt-out of these communications at any time without adversely impacting any current or future job application at UPS. If you opt-out, we will send you a text message to confirm we have processed your cancellation and send you a text message to invite you to sign-up for work-related communications if you are hired."
          description="Disclaimer text informing the user of communications agreement for UPS"
        />
      );
    case 'ITC':
      return (
        <FormattedMessage
          defaultMessage="I agree to allow my phone number to be used for calls or texts. Message & data rates may apply."
          description="Disclaimer text informing the user of communications agreement"
        />
      );
    case 'Standard':
      return (
        <FormattedMessage
          defaultMessage="By checking this box, I agree to receive texts from Fountain sent on behalf of {company} regarding my application process or retainment. Message & data rates may apply. Message frequency varies. Text HELP for more information or STOP to opt-out at any time. View our Privacy Policy and Terms of Services."
          description="Disclaimer text informing the user of communications agreement"
          values={{ company }}
        />
      );
    default:
      return assertUnreachable(consentVariant);
  }
};
